"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Label = exports.Label = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "InputLabelstyles__Label",
  componentId: "sc-8bt1ec-0"
})(function (_ref) {
  var spacing = _ref.theme.spacing;
  return {
    marginBottom: spacing.inline['5xs']
  };
});